import { ExportListResponse } from '@core/interface/export-list.interface';
import { ExportPurchaseTransactionRequestDto } from '@domain/purchase-transaction/dtos/export-purchase-transaction.request.dto';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { PurchaseTransactionService } from '@core/services/entities/purchase-transaction.service';
import { PurchaseTransactionResponseDto } from '@domain/purchase-transaction/dtos/purchase-transaction.response.dto';
import { ListPurchaseTransactionRequestDto } from '@domain/purchase-transaction/dtos/list-purchase-transaction.request.dto';
import { SummaryPurchaseTransactionRequestDto } from '@domain/purchase-transaction/dtos/summary-purchase-transaction.request.dto';
import { SummaryPurchaseTransactionResponseDto } from '@domain/purchase-transaction/dtos/summary-purchase-transaction.response.dto';
import { PurchaseTransactionRepository } from '@domain/purchase-transaction/repositories/purchase-transaction.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PurchaseTransactionRepositoryService
  implements PurchaseTransactionRepository
{
  constructor(private purchaseTransactionService: PurchaseTransactionService) {}

  show(
    request: RefId,
  ): Observable<ApiResponse<PurchaseTransactionResponseDto>> {
    return this.purchaseTransactionService.show(request);
  }

  list(
    request: ListPurchaseTransactionRequestDto,
  ): Observable<ApiResponse<PageableResponse<PurchaseTransactionResponseDto>>> {
    return this.purchaseTransactionService.list(request);
  }

  summary(
    request: SummaryPurchaseTransactionRequestDto,
  ): Observable<ApiResponse<SummaryPurchaseTransactionResponseDto>> {
    return this.purchaseTransactionService.summary(request);
  }

  export(
    request: ExportPurchaseTransactionRequestDto,
  ): Observable<ApiResponse<ExportListResponse>> {
    return this.purchaseTransactionService.export(request);
  }
}
